module.exports = __webpack_public_path__ + "static/img/button_03.d63b22d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button_03.png
// module id = qhn4
// module chunks = 2